import { useEffect, useRef, useState } from "react";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

type Props = {
  value: string;
  tooltipAlignOffset?: number;
  tooltipSideOffset?: number;
  tooltipAlign?: "start" | "center" | "end";
  tooltipSide?: "top" | "right" | "bottom" | "left";
  className?: React.HTMLAttributes<HTMLDivElement>["className"];
};
export const RawTextCell = ({
  value,
  tooltipSide = "top",
  tooltipAlign = "center",
  tooltipSideOffset,
  tooltipAlignOffset,
  className,
}: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isEllipsisActive, setIsEllipsisActive] = useState(false);

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    const checkEllipsis = () => {
      if (ref.current) {
        setIsEllipsisActive(ref.current.scrollWidth > ref.current.clientWidth);
      }
    };

    checkEllipsis();

    window.addEventListener("resize", checkEllipsis);
    return () => {
      window.removeEventListener("resize", checkEllipsis);
    };
  }, [value]);

  return (
    <div
      ref={ref}
      className={cn(
        "overflow-hidden whitespace-nowrap text-ellipsis",
        className,
      )}
    >
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <span>{value}</span>
          </TooltipTrigger>
          {isEllipsisActive && (
            <TooltipContent
              side={tooltipSide}
              align={tooltipAlign}
              sideOffset={tooltipSideOffset}
              alignOffset={tooltipAlignOffset}
            >
              {value}
            </TooltipContent>
          )}
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};
